var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" } },
    [
      _c("div", { staticClass: "commonTitle" }, [_vm._v("开发文档")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "iframe-container" },
        [
          _vm.iframeSrc
            ? _c("iframe", {
                staticStyle: {
                  border: "1px solid #ebeef5",
                  "border-radius": "4px",
                },
                attrs: {
                  src: _vm.iframeSrc,
                  frameborder: "0",
                  width: "100%",
                  height: "700",
                },
              })
            : _c("el-empty", {
                attrs: { description: "请输入页面地址后点击加载" },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }